var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('alarm-popup',{attrs:{"show-modal":_vm.showModal},on:{"close":_vm.closePopup},scopedSlots:_vm._u([{key:"popup-body",fn:function(){return [_c('alarm-popup-body')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }